import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import { Logo } from './Logo';

const footerLinks = {
  services: [
    { name: 'IT Recruitment', path: '/services' },
    { name: 'Software Development', path: '/services' },
    { name: 'Staff Augmentation', path: '/services' },
    { name: 'Consulting', path: '/services' },
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Careers', path: '/careers' },
    { name: 'Portfolio', path: '/case-studies' },
    { name: 'Contact', path: '/contact' },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-[#0a0f1a] border-t border-[#1e293b]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Logo />
            <p className="text-sm text-slate-500 leading-relaxed">
              Sharebox Technologies connects exceptional talent with innovative companies 
              while delivering cutting-edge software solutions.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#111827] border border-[#1e293b] flex items-center justify-center text-slate-400 hover:text-[#0088CC] hover:border-[#0088CC]/50 transition-all"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-[#111827] border border-[#1e293b] flex items-center justify-center text-slate-400 hover:text-[#0088CC] hover:border-[#0088CC]/50 transition-all"
                aria-label="Twitter"
                data-testid="footer-twitter"
              >
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-slate-500 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-slate-500 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#0088CC] mt-0.5 flex-shrink-0" />
                <a 
                  href="mailto:hello@shareboxtech.com"
                  className="text-sm text-slate-500 hover:text-white transition-colors"
                >
                  hello@shareboxtech.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#0088CC] mt-0.5 flex-shrink-0" />
                <a 
                  href="tel:+447438382880"
                  className="text-sm text-slate-500 hover:text-white transition-colors"
                >
                  +44-7438382880
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#0088CC] mt-0.5 flex-shrink-0" />
                <div className="text-sm text-slate-500">
                  <div className="mb-2">
                    <strong className="text-slate-400">UK:</strong><br />
                    3 Thursfield Road<br />
                    Tipton, DY48TJ, UK
                  </div>
                  <div>
                    <strong className="text-slate-400">India:</strong><br />
                    Office No. 403,<br />
                    Swapnali Apartments,<br />
                    Near City Pride Theater,<br />
                    Kothrud,Pune, Maharashtra 411038.
                   
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#1e293b] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-600">
            © {new Date().getFullYear()} Sharebox Technologies Ltd. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-sm text-slate-600 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-slate-600 hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
